export const SET_CALENDAR_DATES = 'ScheduledVisits.SET_CALENDAR_DATES';
export const SET_CARE_PLAN_FREQUENCIES_FOR_RANGE =
  'ScheduledVisits.SET_CARE_PLAN_FREQUENCIES_FOR_RANGE';
export const SET_CALENDAR_VIEW_DATA = 'ScheduledVisits.SET_CALENDAR_VIEW_DATA';
